<template>
  <div class="dropdown d-inline ">
    <soft-button v-show="statusSelected == ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class="dropdown-toggle ms-2"
      data-bs-toggle="dropdown" aria-expanded="true">Estado</soft-button>
    <soft-button v-show="statusSelected != ''" id="navbarDropdownMenuLink2" color="primary" variant="outline" class='dropdown-toggle ms-2 active-filter' 
      data-bs-toggle="dropdown" aria-expanded="false">Estado</soft-button>

    <ul class="dropdown-menu dropdown-menu-lg-start px-2 py-3" aria-labelledby="navbarDropdownMenuLink2">
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='ERROR'? 'active':'']" type="button" @click="handleClick('ERROR')">Error</button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='PENDIENTE'? 'active':'']" type="button" @click="handleClick('PENDIENTE')">Pendiente </button>
      </li>
      <li>
        <button class="dropdown-item border-radius-md" :class="[statusSelected=='FINALIZADO'? 'active':'']" type="button" @click="handleClick('FINALIZADO')">Finalizado</button>
      </li>
      <li>
        <hr class="horizontal my-2" />
      </li>
      <li>
        <button class="dropdown-item border-radius-md text-danger" type="button" @click="handleClick('ERROR')">Limpiar filtros</button>
      </li>
    </ul>   
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";

export default {
  name:"QueuesFilterStatus",
  components: {
    SoftButton,  
  },
  props: {
    filterStatusSelected: {
      type: String,
      required: true
    },
  },
  emits: ['filter-change', 'input'],
  data() {
    return {
    statusSelected:""
    }
  },
  watch: {
    filterStatusSelected(newValue) {
      this.statusSelected = newValue
    },
    statusSelected(newValue){
      this.$emit("input", newValue);
    }
  },
  mounted () {
    this.statusSelected= this.filterStatusSelected;
  },
  methods: {
    handleClick(status) {
      this.statusSelected=status
      this.$emit('filter-change',status)
    },
  },
}
</script>

<style scoped>
.active{
  background-color: rgb(234, 244, 247) !important;
}

.active-filter {
  color: #fff;
  background-color: #344767;
  border-color: #344767;
}
</style>